// File: client/src/App.jsx
import React, { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { trackPageView } from "./analytics.js";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Services from "./pages/Services.jsx";
import Contact from "./pages/Contact.jsx";
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import MVPIDFViewerV2 from "./pages/MVPIDFViewerV2.jsx";
import TestAutocomplete from "./pages/TestAutocomplete.jsx";
import Login from "./pages/Login.jsx";
import Signup from "./pages/Signup.jsx";
import RequireAuth from "./components/RequireAuth.jsx";
import Disclaimer from "./pages/Disclaimer.jsx";
import NormalDepth from "./pages/NormalDepth.jsx";
import DrainageQuickSize from "./pages/DrainageQuickSize.jsx";
function App() {
  const location = useLocation();
  const lastTrackedPath = useRef("");

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (path === lastTrackedPath.current) return;
    lastTrackedPath.current = path;
    trackPageView(path);
  }, [location.pathname, location.search]);
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/start"
            element={
              <RequireAuth>
                <MVPIDFViewerV2 />
              </RequireAuth>
            }
          />
          <Route path="/idf-viewer" element={<MVPIDFViewerV2 />} />
          {/* Drainage tools — separate from IDF */}
          <Route path="/tools" element={<DrainageQuickSize />} />
          <Route path="/tools/quick-size" element={<DrainageQuickSize />} />
          <Route path="/tools/normal-depth" element={<NormalDepth />} />
          <Route path="/test-autocomplete" element={<TestAutocomplete />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;